<script setup>
import { computed } from 'vue';
import Icon from 'next/icon/Icon.vue';
import { useI18n } from 'vue-i18n';
import { useMessageContext } from './provider.js';
import { hasOneDayPassed } from 'shared/helpers/timeHelper';
import { ORIENTATION, MESSAGE_STATUS } from './constants';

defineProps({
  error: { type: String, required: true },
});

const emit = defineEmits(['retry']);

const { orientation, status, createdAt, content, attachments } =
  useMessageContext();

const { t } = useI18n();

const canRetry = computed(() => {
  const hasContent = content.value !== null;
  const hasAttachments = attachments.value && attachments.value.length > 0;
  return !hasOneDayPassed(createdAt.value) && (hasContent || hasAttachments);
});
</script>

<template>
  <div class="flex items-center gap-1.5 text-xs font-medium text-n-ruby-11">
    <span>{{ t('CHAT_LIST.FAILED_TO_SEND') }}</span>
    <div class="relative group">
      <div
        class="grid size-5 cursor-pointer place-content-center rounded-md border border-n-ruby-8/15 bg-n-ruby-3/55 shadow-[inset_0_1px_0_rgba(255,255,255,0.45)]"
      >
        <Icon
          icon="i-lucide-alert-triangle"
          class="text-n-ruby-11 size-[14px]"
        />
      </div>
      <div
        class="absolute bottom-6 w-56 break-words rounded-xl border border-n-strong bg-n-surface-1 px-4 py-3 text-xs text-n-slate-12 shadow-[0px_14px_28px_0px_rgba(0,0,0,0.12)] opacity-0 invisible transition-all group-hover:visible group-hover:opacity-100"
        :class="{
          'ltr:left-0 rtl:right-0': orientation === ORIENTATION.LEFT,
          'ltr:right-0 rtl:left-0': orientation === ORIENTATION.RIGHT,
        }"
      >
        {{ error }}
      </div>
    </div>
    <button
      v-if="canRetry"
      type="button"
      :disabled="status !== MESSAGE_STATUS.FAILED"
      class="grid size-5 cursor-pointer place-content-center rounded-md border border-n-ruby-8/15 bg-n-ruby-3/55 shadow-[inset_0_1px_0_rgba(255,255,255,0.45)]"
      @click="emit('retry')"
    >
      <Icon icon="i-lucide-refresh-ccw" class="text-n-ruby-11 size-[14px]" />
    </button>
  </div>
</template>
